import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const { admin } = useContext(AuthContext);

  // ❗ Only check authentication, NOT role
  if (!admin) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
